<template>
    <v-container fluid>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p class="display-4 text-sm-center">:(</p>
                <div class="text-sm-center">
                    <v-btn class="my-4" x-large color="warning" :to="{name:'Promos'}">Please?</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Boo"
    }
</script>

<style scoped>

</style>